var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBorderRadiusRightBottom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 10.0416C3.35699 10.0416 3.37533 10.0233 3.37533 9.99998C3.37533 9.97665 3.35699 9.95831 3.33366 9.95831C3.31033 9.95831 3.29199 9.97665 3.29199 9.99998C3.29199 10.0233 3.31033 10.0416 3.33366 10.0416",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 13.375C3.35699 13.375 3.37533 13.3567 3.37533 13.3334C3.37533 13.31 3.35699 13.2917 3.33366 13.2917C3.31033 13.2917 3.29199 13.31 3.29199 13.3334C3.29199 13.3567 3.31033 13.375 3.33366 13.375",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 6.70833C3.35699 6.70833 3.37533 6.69 3.37533 6.66667C3.37533 6.64333 3.35699 6.625 3.33366 6.625C3.31033 6.625 3.29199 6.64333 3.29199 6.66667C3.29199 6.69 3.31033 6.70833 3.33366 6.70833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 16.6667C6.625 16.69 6.64333 16.7083 6.66667 16.7083C6.69 16.7083 6.70833 16.69 6.70833 16.6667C6.70833 16.6433 6.69 16.625 6.66667 16.625C6.64333 16.625 6.625 16.6433 6.625 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 16.7083C3.35699 16.7083 3.37533 16.69 3.37533 16.6667C3.37533 16.6433 3.35699 16.625 3.33366 16.625C3.31033 16.625 3.29199 16.6433 3.29199 16.6667C3.29199 16.69 3.31033 16.7083 3.33366 16.7083",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 3.37502C10.0235 3.37502 10.0418 3.35669 10.0418 3.33335C10.0418 3.31002 10.0235 3.29169 10.0002 3.29169C9.97683 3.29169 9.9585 3.31002 9.9585 3.33335C9.9585 3.35669 9.97683 3.37502 10.0002 3.37502",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 3.33335C6.625 3.35669 6.64333 3.37502 6.66667 3.37502C6.69 3.37502 6.70833 3.35669 6.70833 3.33335C6.70833 3.31002 6.69 3.29169 6.66667 3.29169C6.64333 3.29169 6.625 3.31002 6.625 3.33335",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.292 3.33335C13.292 3.35669 13.3103 3.37502 13.3337 3.37502C13.357 3.37502 13.3753 3.35669 13.3753 3.33335C13.3753 3.31002 13.357 3.29169 13.3337 3.29169C13.3103 3.29169 13.292 3.31002 13.292 3.33335",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 3.37502C3.35699 3.37502 3.37533 3.35669 3.37533 3.33335C3.37533 3.31002 3.35699 3.29169 3.33366 3.29169C3.31033 3.29169 3.29199 3.31002 3.29199 3.33335C3.29199 3.35669 3.31033 3.37502 3.33366 3.37502",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.625C16.6433 6.625 16.625 6.64333 16.625 6.66667C16.625 6.69 16.6433 6.70833 16.6667 6.70833C16.69 6.70833 16.7083 6.69 16.7083 6.66667C16.7083 6.64333 16.69 6.625 16.6667 6.625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.29169C16.6433 3.29169 16.625 3.31002 16.625 3.33335C16.625 3.35669 16.6433 3.37502 16.6667 3.37502C16.69 3.37502 16.7083 3.35669 16.7083 3.33335C16.7083 3.31002 16.69 3.29169 16.6667 3.29169",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2988 11.8C17.5748 11.8 17.7986 12.024 17.7988 12.3V17.2512C17.7988 17.3939 17.7376 17.5214 17.6416 17.6125C17.5701 17.7024 17.4692 17.7682 17.3525 17.7922L17.251 17.8019H12.2998C12.0239 17.8018 11.8 17.5778 11.7998 17.3019C11.7998 17.0259 12.0238 16.802 12.2998 16.8019H16.7988V12.3C16.799 12.0241 17.0229 11.8001 17.2988 11.8Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBorderRadiusRightBottom);
export default ForwardRef;